import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.S16} ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
`
